"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var MSOffice365 = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.ImpureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.982 12.25a.805.805 0 0 0-.398 1.5l2.84 1.61a1.55 1.55 0 0 0 1.195.14l4.273-1.217a1.53 1.53 0 0 0 1.107-1.468v-.565H4.982Z",
    fill: "#fff",
    style: {
      mixBlendMode: 'multiply'
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.982 12.25a.805.805 0 0 0-.398 1.5l2.84 1.61a1.55 1.55 0 0 0 1.195.14l4.273-1.217a1.53 1.53 0 0 0 1.107-1.468v-.565H4.982Z",
    fill: "#fff",
    style: {
      mixBlendMode: 'multiply'
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.602.5 1.147 2.625v9.125L8.62 15.5l4.273-1.217a1.53 1.53 0 0 0 1.107-1.468v-9.63a1.528 1.528 0 0 0-1.11-1.47L8.602.5Z",
    fill: "url(#icon_MSOffice365_".concat(randomId, "_a)")
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.185 12.152 1.25-.675A1.09 1.09 0 0 0 5 10.52V5.608a1.092 1.092 0 0 1 .718-1.026L9.75 3.125V2.018A1.58 1.58 0 0 0 7.385.647L2.77 3.28A1.525 1.525 0 0 0 2 4.605v6.84a.803.803 0 0 0 1.185.707Z",
    fill: "url(#icon_MSOffice365_".concat(randomId, "_b)")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 12.25H4.981a.805.805 0 0 0-.398 1.5l2.84 1.61a1.55 1.55 0 0 0 1.195.14A1.556 1.556 0 0 0 9.75 14v-1.75Z",
    fill: "url(#icon_MSOffice365_".concat(randomId, "_c)")
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3.185 12.152 1.25-.675A1.09 1.09 0 0 0 5 10.52V5.608a1.092 1.092 0 0 1 .718-1.026L9.75 3.125V2.018A1.58 1.58 0 0 0 7.385.647L2.77 3.28A1.525 1.525 0 0 0 2 4.605v6.84a.803.803 0 0 0 1.185.707Z",
    fill: "url(#icon_MSOffice365_".concat(randomId, "_d)")
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 12.25H4.981a.805.805 0 0 0-.398 1.5l2.84 1.61a1.55 1.55 0 0 0 1.195.14A1.556 1.556 0 0 0 9.75 14v-1.75Z",
    fill: "url(#icon_MSOffice365_".concat(randomId, "_e)")
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_MSOffice365_".concat(randomId, "_a"),
    x1: 11.299,
    y1: -0.355,
    x2: 11.299,
    y2: 14.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB900"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#EF8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#E25C01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#DB4401"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D83B01"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_MSOffice365_".concat(randomId, "_b"),
    x1: 8.63,
    y1: 0.167,
    x2: 0.79,
    y2: 11.363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#800600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#C72127"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#C13959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#BC4B81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#B95799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B85BA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_MSOffice365_".concat(randomId, "_c"),
    x1: 4.624,
    y1: 13.908,
    x2: 14.859,
    y2: 13.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F32B44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#A4070A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_MSOffice365_".concat(randomId, "_d"),
    x1: 8.79,
    y1: -0.06,
    x2: 7.13,
    y2: 2.31,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_MSOffice365_".concat(randomId, "_e"),
    x1: 11.579,
    y1: 14.137,
    x2: 6.997,
    y2: 13.738,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
});
var _default = MSOffice365;
exports["default"] = _default;